<script>

export default {
    name: 'Rodape'
}

</script>

<template>
    <div class="rodape">

        <div class="bloco1">
            <div class="bloco2">
                <div class="logo">
                    <img class="imagem" src="../assets/imagens/logo-completa.png" alt="">
                </div>

                <div class="bloco4">
                    <div class="bloco3">
                        <div class="contato">
                            <img class="logotipo" src="../assets/imagens/email.png" alt="">
                            <p>administrativo@nacionalindustria-es.com.br</p>
                            <img class="logotipo" src="../assets/imagens/phone.png" alt="">
                            <p>+ 55 (27) 3441-2542</p>
                        </div>
                        <div class="contato">
                            <img class="logotipo" src="../assets/imagens/local.png" alt="">
                            <p>R. CASTELO, Nº 1214 - BLOCO B - JARDIM LIMOEIRO - SERRA/ES.</p>
                            <p>CEP: 29164-030</p>
                        </div>
                    </div>
                </div>
                <div class="bloco_inter">
                    <div class="barra"></div>
                    <div class="conteudo">
                        <img class="arvore" src="../assets/arvore.png" alt="">
                        <p class="text">O Senhor é a Nossa Força.</p>
                    </div>
                    <div class="barra"></div>


                </div>
            </div>
        </div>

    </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Staatliches&display=swap');

@media (max-width: 900px) {
    .rodape {
        width: 100vw;
    }

    .bloco1 {
        width: 100%;
        background-color: #fff;
        padding: 10px;
        box-shadow: 0px 0px 10px 0px #4444446c;

    }

    .bloco4 {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .bloco2 {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-evenly;
        color: #444;
        height: 40%;
        font-size: 0.8rem;
    }

    .bloco3 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        gap: 10px;
    }

    .conteudo {
        display: flex;
        flex-direction: row;
        align-items: end;
        justify-content: center;
    }


    .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 60%;
        background-color: #fff;
        border-radius: 10px;
        padding: 10px;
        margin-bottom: 10px;
    }

    .imagem {
        width: 10rem;
    }

    .barra {
        width: 10px;
        height: 2rem;
        background-color: #444;
    }

    .bloco_inter {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 60%;
        margin: 1rem 0rem;
    }

    
    .titulo {
        color: #000000a8;
        margin-top: 0.5rem;
        font-family: "Staatliches", sans-serif;
        letter-spacing: 2px;
        font-size: 0.6rem;

    }

    .contato {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 10px;
    }

    .arvore {
        width: 15%;
    }

    .logotipo {
        color: #fff;
        width: 1.2rem;
        margin-right: 0rem;
    }

    .text {
        font-size: 0.8rem;
        color: #444;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        border-radius: 5px;
        transition: color 0.3s ease, background-color 0.3s ease;
        background-color: transparent;
        text-align: center;
        padding-left: 15px;
    }

    p {
        font-size: 0.6rem;
    }
}

@media (min-width: 901px) {
    .rodape {
        width: 100vw;
    }

    .bloco1 {
        width: 100%;
        background-color: #fff;
        padding: 5px;
        box-shadow: 0px 0px 10px 0px #4444446c;
    }

    .bloco4 {
        width: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: baseline;
    }

    .bloco2 {
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: space-evenly;
        color: #444;
        height: 40%;
        font-size: 0.8rem;
        width: 100%;
    }

    .conteudo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .barra {
        width: 10px;
        height: 3rem;
        background-color: #444;
    }

    .bloco3 {
        display: flex;
        flex-direction: column;
        align-items: baseline;
        justify-content: baseline;
        font-size: 0.7rem;
        gap: 0px;
    }

    .bloco_inter {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 15%;
    }

    .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 60%;
        background-color: #fff;
        border-radius: 10px;
        margin-left: 2rem;
        padding: 10px;
        width: 20%;
    }

    .imagem {
        width: 15rem;
    }

    .titulo {
        color: #000000a8;
        margin-top: 0.1rem;
        font-family: "Staatliches", sans-serif;
        letter-spacing: 2px;
        font-size: 0.32rem;
        text-align: center;
    }

    .contato {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
    }

    .logotipo {
        color: #fff;
        width: 1.2rem;
        margin-right: 0.2rem;
        margin-top: 0.2rem;
    }

    .text {
        font-size: 0.8rem;
        color: #444;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        border-radius: 5px;
        transition: color 0.3s ease, background-color 0.3s ease;
        background-color: transparent;
        text-align: center;
        padding-left: 15px;
    }

    .arvore {
        width: 15%;
    }

    p {
        margin-right: 1rem;
        font-size: 0.75rem;
        margin-top: 0.2rem;
    }
}
</style>